import moment from "moment";
import React, { useEffect, useState, useReducer } from "react";
import { rootReducer, AppState } from "../../../app-state";
export const Countdown = (props) => {
    const now = Math.round(Date.now() / 1000);
    const [days, setDays] = useState();
    const [hours, setHours] = useState();
    const [minutes, setMinutes] = useState();
    const [seconds, setSeconds] = useState();
    const [state, dispatch] = useReducer(rootReducer, AppState);
    if (!props.start)
        return React.createElement("span", null, "N/A");
    if (now > Number(props.start))
        return React.createElement("span", null, "0:00:00");
    const setStuff = (cntInterval) => {
        var leftTime = Number(props.start) - Math.round(Date.now() / 1000);
        var duration = moment.duration(leftTime, 'seconds');
        if (duration.asSeconds() <= 0) {
            clearInterval(cntInterval);
            if (props.reloadOnZero)
                setTimeout(() => { location.reload(); }, 1000);
        }
        let daysDifference = moment.unix(Number(props.start)).diff(moment(), 'days');
        setDays(daysDifference);
        setHours(duration.hours());
        setMinutes(duration.minutes());
        setSeconds(duration.seconds());
    };
    useEffect(() => {
        var cntInterval = setInterval(() => {
            setStuff(cntInterval);
        }, 1000);
        setStuff(cntInterval);
        return () => {
            clearInterval(cntInterval);
        };
    }, [props.start]);
    return React.createElement("span", { className: "countdown" },
        days > 0 &&
            React.createElement(React.Fragment, null,
                React.createElement("span", { className: "fig days" }, days),
                React.createElement("span", { className: "lab days" }, "d")),
        React.createElement("span", { className: "fig hours" }, hours),
        React.createElement("span", { className: "lab hours" }, "h"),
        React.createElement("span", { className: "fig minutes" }, minutes),
        React.createElement("span", { className: "lab minutes" }, "m"),
        React.createElement("span", { className: "fig seconds" }, seconds),
        React.createElement("span", { className: "lab seconds" }, "s"));
};
